import { InviteResourceType, InviteSource } from '@vyce/core/src/api/types';

import { InviteModuleKey } from './types';

export interface InviteModuleConfig {
  key: InviteModuleKey;
  label: string;
  /** One-line hint under the module name on the "Where" step while nothing is selected */
  description: string;
  /** Module name as the workers list API spells it (same values as USER_DOMAIN_OPTIONS in pay-app) */
  apiModuleName: string;
  resourceType: InviteResourceType;
  sourceKey: keyof Omit<InviteSource, 'all_users'>;
  resourceLabel: string;
  resourceLabelPlural: string;
}

// Display order of the module filters and target sections
export const INVITE_MODULES: InviteModuleConfig[] = [
  {
    key: 'teams',
    label: 'Teams',
    description: 'Add them to a team.',
    apiModuleName: 'Teams',
    resourceType: 'team',
    sourceKey: 'team_ids',
    resourceLabel: 'team',
    resourceLabelPlural: 'teams',
  },
  {
    key: 'time',
    label: 'Time & Attendance',
    description: 'Add them to a location and shift.',
    apiModuleName: 'Time&Attendance',
    resourceType: 'location',
    sourceKey: 'location_ids',
    resourceLabel: 'location',
    resourceLabelPlural: 'locations',
  },
  {
    key: 'payroll',
    label: 'Payroll',
    description: "Add them to a pay schedule. They'll be asked for bank details.",
    apiModuleName: 'Payroll',
    resourceType: 'pay_schedule',
    sourceKey: 'pay_schedule_ids',
    resourceLabel: 'pay schedule',
    resourceLabelPlural: 'pay schedules',
  },
];

export const INVITE_MODULES_CONFIG = INVITE_MODULES.reduce(
  (acc, config) => ({ ...acc, [config.key]: config }),
  {} as Record<InviteModuleKey, InviteModuleConfig>
);

/** Pill value for "no module filter" */
export const ALL_USERS_FILTER = 'all';
